import React from 'react'
const CommonContext = React.createContext<any>({
  currentPath: "",
  currentPage: "",
})
const CommonProvider = CommonContext.Provider 



export const StatusProvider = ({children}: { children: React.ReactNode}) => {
    const [currentPath, setCurrentPath] = React.useState("Home")
    const [currentPage, setCurrentPage] = React.useState("home")

    const addPath = ({path} : {path : String}) => {
      setCurrentPath((oldPath) => oldPath + " / " + path)
    }

    const removePath = () => {
      let splitted = currentPath.split(" / ")
      splitted.pop()
      setCurrentPath(splitted.join(" / "))
    }

    
   return (
      <CommonProvider value={{currentPath, currentPage, setCurrentPath, addPath, removePath, setCurrentPage}}>
        {children}
      </CommonProvider>
    )
  }
  
export default CommonContext
